import update from 'immutability-helper'
import {
  SET_SELECTED_INVOICE,
  SET_SELECTED_EMISOR,
  SET_CREATE_FORM_VALUE,
  ADD_CONCEPT,
  DELETE_CONCEPT,
  SET_CONCEPT_VALUE,
  ADD_TAX,
  DELETE_TAX,
  RESET_CREATE_FORM,
  SET_FILTER_VALUE,
  RESET_INVOICES_FILTERS,
  SET_CREATE_PAYMENT_COMPLEMENT_FORM_VALUE,
  RESET_CREATE_PAYMENT_COMPLEMENT_FORM,
  SET_CREATE_CREDIT_NOTE_FORM_VALUE,
  ADD_CREDIT_NOTE_CONCEPT,
  SET_CREDIT_NOTE_CONCEPT_VALUE,
  DELETE_CREDIT_NOTE_CONCEPT,
  ADD_CREDIT_NOTE_TAX,
  DELETE_CREDIT_NOTE_TAX,
  RESET_CREATE_CREDIT_NOTE_FORM,
  SET_SYNC_VALUE,
  SET_SYNC_FORM_VALUE,
  RESET_SYNC_VALUES,
  SET_FILTER,
  SET_HEADER_VALUE,
  RESET_HEADERS,
  SET_HIDE_SAVE_PROGRESS,
  UPDATE_TAX,
} from 'actions/invoices'

/** interfaces */
import { InvoicesStore } from 'models/redux'
import { ReduxAction } from 'models/thunk'
import { RESET_APP_STATE } from 'store/shared.actions'
import { Tax } from 'models/invoices.models'
import { IInvoiceCreationTaxRequest } from 'services/Invoices/invoices.models'

const initialInvoices: InvoicesStore = {
  filter: {
    type: null,
    status: null,
    startDate: null,
    endDate: null,
    receptor: '',
    search: '',
    advance: false,
  },
  headers: {
    createdAt: true,
    hour: false,
    serie: true,
    uuid: false,
    clients: true,
    emisor: false,
    subtotal: false,
    taxes: false,
    total: true,
    movementType: true,
    status: true,
    art69B: true,
    statusPayment: true,
    sent: true,
  },
  form: {
    conceptos: [],
    condiciones: '',
    emisor: null,
    folio: '',
    formaPago: null,
    metodoPago: null,
    moneda: null,
    receptor: null,
    serie: null,
    tipo: null,
    tipoCambio: '',
    usoCfdi: null,
    version: '',
  },
  hideSaveProgress: false,
  paymentComplementForm: {
    fechaPago: '',
    formaPago: null,
    moneda: null,
    tipoCambio: '',
    monto: '0.0',
    numeroOperacion: '',
    rfcOrigen: '',
    rfcBeneficiario: '',
    nombreBanco: '',
    cuentaBeneficiario: '',
    cuentaOrdenante: '',
    tipoCadenaPago: null,
    certificadoPago: '',
    cadenaPago: '',
    selloPago: '',
    serie: '',
    folio: '',
    metodoPago: null,
    numeroParcialidad: '',
    importeSaldoAnterior: '',
    importePagado: '',
    totalOriginal: '',
    tipoCambioDR: '',
  },
  creditNoteForm: {
    idCreditNote: 0,
    usoCfdi: null,
    moneda: null,
    metodoPago: null,
    formaPago: null,
    condiciones: '',
    conceptos: [],
    tipoRelacion: null,
    exchangeRate: 0,
    uuid: '',
    serie: '',
    folio: '',
  },
  active: 0,
  selected: null,
  selectedList: [],
}

const defaultAction: ReduxAction<any> = {
  type: '',
  value: '',
}

const invoice = (state = initialInvoices, action = defaultAction) => {
  switch (action.type) {
    // #region Invoices List functionality
    case SET_SELECTED_INVOICE:
      return update(state, { selected: { $set: action.value } })
    case SET_SELECTED_EMISOR:
      return update(state, { selectedEmisor: { $set: action.value } })
    // #endregion

    // #region Create IInvoice Form
    case SET_CREATE_FORM_VALUE: {
      return update(state, {
        form: {
          [action.value.name]: { $set: action.value.value },
        },
      })
    }
    case ADD_CONCEPT: {
      return update(state, {
        form: {
          conceptos: { $push: [action.value] },
        },
      })
    }
    case DELETE_CONCEPT: {
      // const index = state.form.conceptos.findIndex(c => c.uuid === action.value)
      const index = Number(action.value)
      if (index === -1) return state
      return update(state, { form: { conceptos: { $splice: [[index, 1]] } } })
    }
    case SET_CONCEPT_VALUE: {
      // const index = state.form.conceptos.findIndex(
      //   c => c.uuid === action.value.id
      // )
      const index = Number(action.value.id)
      if (index === -1) return state
      return update(state, {
        form: {
          conceptos: {
            [index]: {
              [action.value.name]: { $set: action.value.value },
            },
          },
        },
      })
    }
    case ADD_TAX: {
      // const conceptIndex = state.form.conceptos.findIndex(
      //   c => c.uuid === action.value.conceptId
      // )
      const conceptIndex = Number(action.value.conceptId)
      if (conceptIndex === -1) return state
      return update(state, {
        form: {
          conceptos: {
            [conceptIndex]: {
              impuestos: { $push: [action.value.tax] },
            },
          },
        },
      })
    }
    case UPDATE_TAX: {
      // const conceptIndex = state.form.conceptos.findIndex(
      //   c => c.uuid === action.value.conceptId
      // )
      const conceptIndex = Number(action.value.conceptId)
      if (conceptIndex === -1) return state

      const taxIndex = (
        state.form.conceptos[conceptIndex]
          .impuestos as IInvoiceCreationTaxRequest[]
      ).findIndex(t => t.uuid === action.value.tax.uuid)
      if (taxIndex === -1) return state

      return update(state, {
        form: {
          conceptos: {
            [conceptIndex]: {
              impuestos: {
                [taxIndex]: { $set: action.value.tax },
              },
            },
          },
        },
      })
    }
    case DELETE_TAX: {
      // const conceptIndex = state.form.conceptos.findIndex(
      //   c => c.uuid === action.value.conceptId
      // )
      const conceptIndex = Number(action.value.conceptId)
      if (conceptIndex === -1) return state
      const taxIndex = (
        state.form.conceptos[conceptIndex].impuestos as Tax[]
      ).findIndex(t => t.uuid === action.value.taxId)
      if (taxIndex === -1) return state
      return update(state, {
        form: {
          conceptos: {
            [conceptIndex]: {
              impuestos: { $splice: [[taxIndex, 1]] },
            },
          },
        },
      })
    }
    case RESET_CREATE_FORM:
      return update(state, { form: { $set: initialInvoices.form } })
    // #endregion

    case SET_HIDE_SAVE_PROGRESS:
      return update(state, { hideSaveProgress: { $set: action.value } })

    // #region Create Payment Complement Form
    case SET_CREATE_PAYMENT_COMPLEMENT_FORM_VALUE:
      return update(state, {
        paymentComplementForm: {
          [action.value.name]: { $set: action.value.value },
        },
      })
    case RESET_CREATE_PAYMENT_COMPLEMENT_FORM:
      return update(state, {
        paymentComplementForm: { $set: initialInvoices.paymentComplementForm },
      })
    // #endregion

    // #region Create credit note Form
    case SET_CREATE_CREDIT_NOTE_FORM_VALUE:
      return update(state, {
        creditNoteForm: {
          [action.value.name]: { $set: action.value.value },
        },
      })
    case ADD_CREDIT_NOTE_CONCEPT: {
      return update(state, {
        creditNoteForm: {
          conceptos: { $push: [action.value] },
        },
      })
    }
    case SET_CREDIT_NOTE_CONCEPT_VALUE: {
      const index = state.creditNoteForm.conceptos.findIndex(
        c => c.uuid === action.value.id
      )
      if (index === -1) return state
      return update(state, {
        creditNoteForm: {
          conceptos: {
            [index]: {
              [action.value.name]: { $set: action.value.value },
            },
          },
        },
      })
    }
    case DELETE_CREDIT_NOTE_CONCEPT: {
      const index = state.creditNoteForm.conceptos.findIndex(
        c => c.uuid === action.value
      )
      if (index === -1) return state
      return update(state, {
        creditNoteForm: {
          conceptos: { $splice: [[index, 1]] },
        },
      })
    }
    case ADD_CREDIT_NOTE_TAX: {
      const conceptIndex = state.creditNoteForm.conceptos.findIndex(
        c => c.uuid === action.value.conceptId
      )
      if (conceptIndex === -1) return state
      return update(state, {
        creditNoteForm: {
          conceptos: {
            [conceptIndex]: {
              impuestos: { $push: [action.value.tax] },
            },
          },
        },
      })
    }
    case DELETE_CREDIT_NOTE_TAX: {
      const conceptIndex = state.creditNoteForm.conceptos.findIndex(
        c => c.uuid === action.value.conceptId
      )
      if (conceptIndex === -1) return state
      const taxIndex = state.creditNoteForm.conceptos[
        conceptIndex
      ].impuestos.findIndex(t => t.uuid === action.value.taxId)
      if (taxIndex === -1) return state
      return update(state, {
        creditNoteForm: {
          conceptos: {
            [conceptIndex]: {
              impuestos: { $splice: [[taxIndex, 1]] },
            },
          },
        },
      })
    }
    case RESET_CREATE_CREDIT_NOTE_FORM:
      return update(state, {
        creditNoteForm: { $set: initialInvoices.creditNoteForm },
      })
    // #endregion

    // #region Filters Form
    case SET_FILTER:
      return update(state, {
        filter: {
          $merge: {
            type: action.value?.type ?? null,
            status: action.value?.status ?? null,
            startDate: action.value?.startDate ?? null,
            endDate: action.value?.endDate ?? null,
            receptor: action.value?.receptor ?? null,
          },
        },
      })
    case SET_FILTER_VALUE:
      return update(state, {
        filter: {
          [action.value.name]: { $set: action.value.value },
        },
      })
    case RESET_INVOICES_FILTERS:
      return update(state, {
        filter: {
          $merge: {
            ...initialInvoices.filter,
            advance: state.filter.advance,
          },
        },
      })
    // #endregion

    // #region Selected Headers
    case SET_HEADER_VALUE:
      return update(state, {
        headers: {
          [action.value.name]: { $set: action.value.value },
        },
      })
    case RESET_HEADERS:
      return update(state, {
        headers: { $set: initialInvoices.headers },
      })
    // #endregion

    // #region Sync Form and Functionality
    case SET_SYNC_VALUE:
      return update(state, {
        sync: {
          [action.value.key]: { $set: action.value.value },
        },
      })
    case SET_SYNC_FORM_VALUE:
      return {
        ...state,
        sync: {
          ...state.sync,
          [action.value.key]: action.value.value,
        },
      }
    case RESET_SYNC_VALUES:
      return update(state, { sync: { $set: initialInvoices.sync } })
    // #endregion
    case RESET_APP_STATE:
      return update(state, {
        selectedEmisor: { $set: undefined },
        filter: {
          $set: initialInvoices.filter,
        },
      })
    default:
      return state
  }
}

export default invoice
